/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_S2Inputs */

const en_tut_denah_s2 = /** @type {(inputs: Tut_Denah_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An owner or admin presses **Edit draft denah** in the header. Everything in the editor is **private** and does not touch the office people are using.`)
};

const id_tut_denah_s2 = /** @type {(inputs: Tut_Denah_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilik atau admin menekan **Edit draft denah** di header untuk membuka editor. Perubahan di sini **privat** dan tidak mengubah kantor yang sedang dipakai orang.`)
};

/**
* | output |
* | --- |
* | "An owner or admin presses **Edit draft denah** in the header. Everything in the editor is **private** and does not touch the office people are using." |
*
* @param {Tut_Denah_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_s2 = /** @type {((inputs?: Tut_Denah_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_s2(inputs)
	return en_tut_denah_s2(inputs)
});